import {Routes} from '@angular/router';
import {authGuard} from './components/login/auth-guard/auth-guard.component';
import {DefaultLayoutComponent} from './components/layouts/default-layout/default-layout.component';
import {InscriptionLayoutComponent} from './components/layouts/inscription-layout/inscription-layout.component';
import {MsalGuard} from "@azure/msal-angular";
import {InscriptionComponent} from "./components/inscription/inscription/inscription.component";
import {InscriptionResolver} from "./inscription.resolver";

export const routes: Routes = [
    {
        path: '',
        component: InscriptionLayoutComponent,
        resolve: {showInscription: InscriptionResolver},
        children: [
          {
            path: '',
            component: InscriptionComponent,
            data: {stepList: ['young', 'resp', 'place']}
          },
          {
            path: 'add-young',
            component: InscriptionComponent,
            data: {stepList: ['young', 'place'], isAddYoung: true},
            canActivate: [MsalGuard, authGuard]
          },
          {
            path: 'add-events',
            component: InscriptionComponent,
            data: {stepList: ['place']},
            canActivate: [MsalGuard, authGuard]
          }
        ]
    },
    {
        path: '',
        component: DefaultLayoutComponent,
        resolve: {showInscription: InscriptionResolver},
        children: [
            {
                path: 'login',
                canActivate: [MsalGuard],
                loadComponent: () => import('./components/login/login.component').then(m => m.LoginComponent)
            },
            {
                path: 'success',
                pathMatch: 'full',
                loadComponent: () => import('./components/inscription-succeed/inscription-succeed.component').then(m => m.InscriptionSucceedComponent)
            },
            {
                path: 'complete-profile',
                canActivate: [MsalGuard],
                loadComponent: () => import('./components/complete-profile/complete-profile.component').then(m => m.CompleteProfileComponent)
            },
            {
                path: 'children',
                loadComponent: () => import('./components/home/children-list.component').then(m => m.ChildrenListComponent),
                canActivate: [MsalGuard, authGuard]
            },
            {
                path: 'info',
                loadChildren: () => import('./components/young-info/young-info.module').then(m => m.YoungInfoModule),
                canActivate: [MsalGuard, authGuard]
            }
        ]
    },
    {path: '**', redirectTo: ''}
];
